import React from 'react';
import { useHistory } from 'react-router-dom';
import '../styles/TopBar.css';

export default function UsefulLink() {
    const history = useHistory();
    const goToLink = (linkString) => {
        history.push(linkString);
    };
    return (
        <div className='navBarPair'>
            <ul className='footerNav'>
                <li
                className='liHover'
                    onClick={() => {
                        goToLink('/');
                    }}
                >
                    Home
                </li>
                <li
                className='liHover'
                    onClick={() => {
                        goToLink('/Nosotros');
                    }}
                >
                    Nosotros
                </li>
                <li
                className='liHover'
                    onClick={() => {
                        goToLink('/services-v1');
                    }}
                >
                    Servicios
                </li>
                <li
                className='liHover'
                    onClick={() => {
                        goToLink('/contact-v1');
                    }}
                >
                    Contacto
                </li>
            </ul>
            {/* <!-- /.one-half --> */}
            <div className='redesSociales'>
                <div className='instagramRed'>
                    <a href='https://instagram.com/godinezmadrigalac?igshid=YmMyMTA2M2Y='>
                        <svg
                            viewBox='0 0 32 32'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                        >
                            <rect
                                x='2'
                                y='2'
                                width='28'
                                height='28'
                                rx='6'
                                fill='url(#paint0_radial_87_7153)'
                            />
                            <rect
                                x='2'
                                y='2'
                                width='28'
                                height='28'
                                rx='6'
                                fill='url(#paint1_radial_87_7153)'
                            />
                            <rect
                                x='2'
                                y='2'
                                width='28'
                                height='28'
                                rx='6'
                                fill='url(#paint2_radial_87_7153)'
                            />
                            <path
                                d='M23 10.5C23 11.3284 22.3284 12 21.5 12C20.6716 12 20 11.3284 20 10.5C20 9.67157 20.6716 9 21.5 9C22.3284 9 23 9.67157 23 10.5Z'
                                fill='white'
                            />
                            <path
                                fill-rule='evenodd'
                                clip-rule='evenodd'
                                d='M16 21C18.7614 21 21 18.7614 21 16C21 13.2386 18.7614 11 16 11C13.2386 11 11 13.2386 11 16C11 18.7614 13.2386 21 16 21ZM16 19C17.6569 19 19 17.6569 19 16C19 14.3431 17.6569 13 16 13C14.3431 13 13 14.3431 13 16C13 17.6569 14.3431 19 16 19Z'
                                fill='white'
                            />
                            <path
                                fill-rule='evenodd'
                                clip-rule='evenodd'
                                d='M6 15.6C6 12.2397 6 10.5595 6.65396 9.27606C7.2292 8.14708 8.14708 7.2292 9.27606 6.65396C10.5595 6 12.2397 6 15.6 6H16.4C19.7603 6 21.4405 6 22.7239 6.65396C23.8529 7.2292 24.7708 8.14708 25.346 9.27606C26 10.5595 26 12.2397 26 15.6V16.4C26 19.7603 26 21.4405 25.346 22.7239C24.7708 23.8529 23.8529 24.7708 22.7239 25.346C21.4405 26 19.7603 26 16.4 26H15.6C12.2397 26 10.5595 26 9.27606 25.346C8.14708 24.7708 7.2292 23.8529 6.65396 22.7239C6 21.4405 6 19.7603 6 16.4V15.6ZM15.6 8H16.4C18.1132 8 19.2777 8.00156 20.1779 8.0751C21.0548 8.14674 21.5032 8.27659 21.816 8.43597C22.5686 8.81947 23.1805 9.43139 23.564 10.184C23.7234 10.4968 23.8533 10.9452 23.9249 11.8221C23.9984 12.7223 24 13.8868 24 15.6V16.4C24 18.1132 23.9984 19.2777 23.9249 20.1779C23.8533 21.0548 23.7234 21.5032 23.564 21.816C23.1805 22.5686 22.5686 23.1805 21.816 23.564C21.5032 23.7234 21.0548 23.8533 20.1779 23.9249C19.2777 23.9984 18.1132 24 16.4 24H15.6C13.8868 24 12.7223 23.9984 11.8221 23.9249C10.9452 23.8533 10.4968 23.7234 10.184 23.564C9.43139 23.1805 8.81947 22.5686 8.43597 21.816C8.27659 21.5032 8.14674 21.0548 8.0751 20.1779C8.00156 19.2777 8 18.1132 8 16.4V15.6C8 13.8868 8.00156 12.7223 8.0751 11.8221C8.14674 10.9452 8.27659 10.4968 8.43597 10.184C8.81947 9.43139 9.43139 8.81947 10.184 8.43597C10.4968 8.27659 10.9452 8.14674 11.8221 8.0751C12.7223 8.00156 13.8868 8 15.6 8Z'
                                fill='white'
                            />
                            <defs>
                                <radialGradient
                                    id='paint0_radial_87_7153'
                                    cx='0'
                                    cy='0'
                                    r='1'
                                    gradientUnits='userSpaceOnUse'
                                    gradientTransform='translate(12 23) rotate(-55.3758) scale(25.5196)'
                                >
                                    <stop stop-color='#B13589' />
                                    <stop
                                        offset='0.79309'
                                        stop-color='#C62F94'
                                    />
                                    <stop
                                        offset='1'
                                        stop-color='#8A3AC8'
                                    />
                                </radialGradient>
                                <radialGradient
                                    id='paint1_radial_87_7153'
                                    cx='0'
                                    cy='0'
                                    r='1'
                                    gradientUnits='userSpaceOnUse'
                                    gradientTransform='translate(11 31) rotate(-65.1363) scale(22.5942)'
                                >
                                    <stop stop-color='#E0E8B7' />
                                    <stop
                                        offset='0.444662'
                                        stop-color='#FB8A2E'
                                    />
                                    <stop
                                        offset='0.71474'
                                        stop-color='#E2425C'
                                    />
                                    <stop
                                        offset='1'
                                        stop-color='#E2425C'
                                        stop-opacity='0'
                                    />
                                </radialGradient>
                                <radialGradient
                                    id='paint2_radial_87_7153'
                                    cx='0'
                                    cy='0'
                                    r='1'
                                    gradientUnits='userSpaceOnUse'
                                    gradientTransform='translate(0.500002 3) rotate(-8.1301) scale(38.8909 8.31836)'
                                >
                                    <stop
                                        offset='0.156701'
                                        stop-color='#406ADC'
                                    />
                                    <stop
                                        offset='0.467799'
                                        stop-color='#6A45BE'
                                    />
                                    <stop
                                        offset='1'
                                        stop-color='#6A45BE'
                                        stop-opacity='0'
                                    />
                                </radialGradient>
                            </defs>
                        </svg>
                        <p>Instagram</p>
                    </a>
                </div>
                <div className='twitterRed'>
                    <a href='https://twitter.com/godinezmadrigal?s=21&t=-uTOpMat0PyyvrXKiv4V3A'>
                        <svg
                            viewBox='0 0 32 32'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                        >
                            <path
                                d='M11.7887 28C8.55374 28 5.53817 27.0591 3 25.4356C5.15499 25.5751 8.95807 25.2411 11.3236 22.9848C7.76508 22.8215 6.16026 20.0923 5.95094 18.926C6.25329 19.0426 7.6953 19.1826 8.50934 18.856C4.4159 17.8296 3.78793 14.2373 3.92748 13.141C4.695 13.6775 5.99745 13.8641 6.50913 13.8174C2.69479 11.0882 4.06703 6.98276 4.74151 6.09635C7.47882 9.88867 11.5812 12.0186 16.6564 12.137C16.5607 11.7174 16.5102 11.2804 16.5102 10.8316C16.5102 7.61092 19.1134 5 22.3247 5C24.0025 5 25.5144 5.71275 26.5757 6.85284C27.6969 6.59011 29.3843 5.97507 30.2092 5.4432C29.7934 6.93611 28.4989 8.18149 27.7159 8.64308C27.7224 8.65878 27.7095 8.62731 27.7159 8.64308C28.4037 8.53904 30.2648 8.18137 31 7.68256C30.6364 8.52125 29.264 9.91573 28.1377 10.6964C28.3473 19.9381 21.2765 28 11.7887 28Z'
                                fill='#47ACDF'
                            />
                        </svg>
                        <p>Twitter</p>
                    </a>
                </div>
                <div className='facebookRed'>
                    <a href='https://www.facebook.com/godinezmadrigalmx/'>
                        <svg
                            viewBox='0 0 48 48'
                            version='1.1'
                            xmlns='http://www.w3.org/2000/svg'
                        >
                            <title>Facebook-color</title>
                            <desc>Created with Sketch.</desc>
                            <defs></defs>
                            <g
                                id='Icons'
                                stroke='none'
                                stroke-width='1'
                                fill='none'
                                fill-rule='evenodd'
                            >
                                <g
                                    id='Color-'
                                    transform='translate(-200.000000, -160.000000)'
                                    fill='#4460A0'
                                >
                                    <path
                                        d='M225.638355,208 L202.649232,208 C201.185673,208 200,206.813592 200,205.350603 L200,162.649211 C200,161.18585 201.185859,160 202.649232,160 L245.350955,160 C246.813955,160 248,161.18585 248,162.649211 L248,205.350603 C248,206.813778 246.813769,208 245.350955,208 L233.119305,208 L233.119305,189.411755 L239.358521,189.411755 L240.292755,182.167586 L233.119305,182.167586 L233.119305,177.542641 C233.119305,175.445287 233.701712,174.01601 236.70929,174.01601 L240.545311,174.014333 L240.545311,167.535091 C239.881886,167.446808 237.604784,167.24957 234.955552,167.24957 C229.424834,167.24957 225.638355,170.625526 225.638355,176.825209 L225.638355,182.167586 L219.383122,182.167586 L219.383122,189.411755 L225.638355,189.411755 L225.638355,208 L225.638355,208 Z'
                                        id='Facebook'
                                    ></path>
                                </g>
                            </g>
                        </svg>
                        <p>Facebook</p>
                    </a>
                </div>
            </div>

            {/* <!-- /.one-half --> */}
        </div>
    );
}
